import React from 'react';
import PropTypes from 'prop-types';

import { Drawer, Grid } from '@mui/material';

const AdvisorGrowBusinessDrawer = ({ open, onClose }) => {
  const list = (
    <Grid container className="drawer-max-width">
      <Grid container className="drawer-hdr">
        <Grid item xs={11}>
          <span className="subhead">Grow Your Business</span>
        </Grid>
        <Grid item xs={1} className="pull-right">
          <a role="link" tabIndex={0} onClick={onClose} onKeyDown={onClose}>
            <img src="/plus_frontend/assets/svg/x-close.svg" alt="close" />
          </a>
        </Grid>
      </Grid>
    </Grid>
  );

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      {list}
    </Drawer>
  );
};

AdvisorGrowBusinessDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AdvisorGrowBusinessDrawer;
